// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"Label\"] {\n  display: flex;\n  align-items: center;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n  [name=\"Label\"].inline {\n    display: inline-flex;\n  }\n  [name=\"Label\"] > input[type=\"checkbox\"][name=\"Checkbox\"] {\n    margin-right: 7px;\n  }\n", ""]);
// Exports
module.exports = exports;
